import './PlayerForm.css'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Formik, Field } from 'formik'

import { useAddPlayerMutation, useUpdatePlayerMutation } from '../../redux/playersService/playersApiSlice'
import { Header } from '../../components/Header/Header'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { BottomMenu } from '../../components/BottomMenu/BottomMenu'

import { isValidEmail } from './externalFunctions'

const PlayerCreation = () => {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const updatedPlayer = JSON.parse(sessionStorage.getItem('updatedPlayer'))
	const [createPlayer] = useAddPlayerMutation()
	const [updatePlayer] = useUpdatePlayerMutation()
	const communityUid = localStorage.getItem('communityUid')

	// Валидируем LastName
	const validateLastName = (valueLastName) => {
		const regex = /^(\s*)$/

		if (regex.test(valueLastName)) {
			return true
		}
	}

	// Валидируем FirstName
	const validateFirstName = (valueFirstName) => {
		const regex = /^(\s*)$/

		if (regex.test(valueFirstName)) {
			return true
		}
	}

	// Валидируем BirthDate
	const validateBirthDate = (valueBirthDate) => {
		const parts = valueBirthDate.split('-')
		const year = parts[0]

		if (year.startsWith('0')) {
			return true
		} else {
			return false
		}
	}

	// Валидируем BirthYear
	const validateBirthYear = (valueBirthYear) => {
		const string = valueBirthYear?.toString()

		if (string) {
			if (string?.length > 4) {
				return true
			} else if (string?.length < 4) {
				return true
			} else {
				return false
			}
		}
	}

	// Валидируем Email
	const validateEmail = (valueEmail) => {
		if (valueEmail?.length > 0) {
			if (isValidEmail(valueEmail)) {
				return false
			} else {
				return true
			}
		} else {
			return false
		}
	}

	// Валидируем Phone
	const validatePhone = (valuePhone) => {
		const phoneNumberRegex = /^((\+7|8)?(9\d{9}))$/g

		if (valuePhone) {
			if (phoneNumberRegex.test(valuePhone)) {
				return false
			} else {
				return true
			}
		} else {
			return false
		}
	}

	// Заменяем на нужный нам формат Phone
	const replacePhone = (phoneNuber) => {
		if (phoneNuber.startsWith('8')) {
			return `+7${phoneNuber.slice(1)}`
		} else if (phoneNuber.startsWith('9')) {
			return `+7${phoneNuber}`
		}
		else if (phoneNuber.startsWith('+7')) {
			return `${phoneNuber}`
		}
	}

	const sendDataForm = async (values) => {
		try {
			const body = {
				'gender': values?.gender,
				'last_name': values?.lastName,
				'first_name': values?.firstName,
				'middle_name': values?.middleName,
				'birth_date': values?.birthDate ? values?.birthDate : null,
				'birth_year': values?.birthYear ? values?.birthYear : null,
				'email': values?.email,
				'mobile': replacePhone(values?.phone),
				'community_uids': [communityUid]
			}

			let response = null
			if (updatedPlayer) {
				response = await updatePlayer({ body, player_uid: updatedPlayer?.uid }).unwrap()
			} else {
				response = await createPlayer({ body }).unwrap()
			}

			if (response?.error?.status === 401) {
				navigate('/')
			} else if (response?.error) {
				return
			} else {
				navigate('/account/players')
			}
		} catch (e) {
			console.log('createPlayer catch error', e)
		}
	}

	return (
		<>
			<Header
				title={updatedPlayer ? t('Edition') : t('Add player')}
				backButton={true}
			/>

			<div className="player-form__container">
				<Formik
					initialValues={{
						lastName: updatedPlayer?.last_name ? updatedPlayer?.last_name : '',
						firstName: updatedPlayer?.first_name ? updatedPlayer?.first_name : '',
						middleName: updatedPlayer?.middle_name ? updatedPlayer?.middle_name : '',
						gender: updatedPlayer?.gender ? updatedPlayer?.gender : null,
						birthDate: updatedPlayer?.birth_date ? updatedPlayer?.birth_date : '',
						birthYear: updatedPlayer?.birth_year ? updatedPlayer?.birth_year : '',
						email: updatedPlayer?.email ? updatedPlayer?.email : '',
						phone: updatedPlayer?.mobile ? updatedPlayer?.mobile : ''
					}}
					onSubmit={async (values) => {
						console.log(values)

						await sendDataForm(values)
					}}
				>
					{({ values, errors, touched, handleSubmit, handleChange}) => (
						<form onSubmit={ handleSubmit } noValidate>
							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Last name') } <span style={{ color: 'red' }}>*</span>
								</label>

								<Field
									value={values.lastName}
									validate={validateLastName}
									onChange={handleChange}
									type="text"
									name="lastName"
									as={Input}
									borderColor={errors.lastName && touched.lastName ? '#F20505' : ''}
								/>

								{
									errors.lastName && touched.lastName &&
										<p className="player-form__error">
											{ t('Enter last name') }
										</p>
								}
							</div>

							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Player name') } <span style={{ color: 'red' }}>*</span>
								</label>

								<Field
									value={values.firstName}
									validate={validateFirstName}
									onChange={handleChange}
									type="text"
									name="firstName"
									as={Input}
									borderColor={errors.firstName && touched.firstName ? '#F20505' : ''}
								/>

								{
									errors.firstName && touched.firstName &&
										<p className="player-form__error">
											{t('Enter player name')}
										</p>
								}
							</div>

							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Middle name') }
								</label>

								<Field
									value={values.middleName}
									onChange={handleChange}
									type="text"
									name="middleName"
									as={Input}
								/>
							</div>

							<div className="player-form__inputs-radio">
								<p className="inputs-radio__title">
									{ t('Gender') }
								</p>

								<div className="inputs-radio__container">
									<Field
										id="player-gender__male"
										name="gender"
										type="radio"
										value="male"
										checked={values.gender === 'male'}
										className="inputs-radio__button"
									/>

									<label htmlFor="player-gender__male">
										{ t('Male') }
									</label>
								</div>

								<div className="inputs-radio__container">
									<Field
										id="player-gender__female"
										name="gender"
										type="radio"
										value="female"
										checked={values.gender === 'female'}
										className="inputs-radio__button"
									/>

									<label htmlFor="player-gender__female">
										{ t('Female') }
									</label>
								</div>
							</div>

							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Birth date') }
								</label>

								<Field
									value={values.birthDate}
									onChange={handleChange}
									validate={validateBirthDate}
									type="date"
									name="birthDate"
									borderColor={errors.birthDate && touched.birthDate ? '#F20505' : ''}
									as={Input}
								/>

								{
									errors.birthDate &&
										<p className="player-form__error">
											{ t('Incorrect birth date') }
										</p>
								}
							</div>

							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Birth year') }
								</label>

								<Field
									value={
										values.birthDate.slice(0, 4) ?
											values.birthDate.slice(0, 4)
											:
											values.birthYear
									}
									onChange={handleChange}
									validate={validateBirthYear}
									type="number"
									borderColor={errors.birthYear ? '#F20505' : ''}
									name="birthYear"
									as={Input}
									readOnly={values.birthDate}
								/>

								{
									errors.birthYear &&
										<p className="player-form__error">
											{ t('Incorrect birth year') }
										</p>
								}
							</div>

							<div className="player-form__input">
								<label className="player-form__input-label">
									{ t('Email') }
								</label>

								<Field
									value={values.email}
									onChange={handleChange}
									validate={validateEmail}
									type="email"
									borderColor={errors.email && touched.email ? '#F20505' : ''}
									name="email"
									as={Input}
								/>

								{
									errors.email && touched.email &&
										<p className="player-form__error">
											{ t('Invalid email') }
										</p>
								}
							</div>

							<div className="player-form__input">
								<label htmlFor="phone" className="player-form__input-label">
									{ t('Phone number') }
								</label>

								<Field
									value={values.phone}
									onChange={handleChange}
									validate={validatePhone}
									type="text"
									name="phone"
									borderColor={errors.phone && touched.phone ? '#F20505' : ''}
									as={Input}
								/>

								{
									errors.phone && touched.phone &&
										<p className="player-form__error">
											{ t('Invalid phone number') }
										</p>
								}
							</div>

							<div className="player-form__submit">
								<Button type={ 'submit' } title={ t('Save') } />
							</div>
						</form>
					)}
				</Formik>
			</div>

			<BottomMenu />
		</>
	)
}

export default PlayerCreation
